export default __webpack_public_path__ + "static/media/logo_EDO_project.959288f6.svg";